customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class e extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.currentTrigger = null;
        this.addEventListener("product-info:loaded", ({ target: e }) => {
          e.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }
      
      hide(e = !1) {
        let t = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy);
        const isLandingModal = this.currentTrigger && this.currentTrigger.getAttribute('data-landing') === 'true';
       
          if (!isLandingModal) {
            this.modalContent.innerHTML = "";
          }
        if (e) {
          this.openedBy = null;
          this.currentTrigger = null;
        }
        super.hide();
      }
      
      show(e) {
        this.currentTrigger = e;

          this.isLandingModal = e && e.getAttribute && e.getAttribute('data-landing') === 'true';
          if (e && e.getAttribute && e.getAttribute('data-landing') === 'true') {
           
            super.show(e); 
            return;         
          }

        e.setAttribute("aria-disabled", !0);
        e.classList.add("loading");
        e.querySelector(".loading__spinner").classList.remove("hidden");
        
        // Get variant ID from trigger button if it's from-pdp
        const triggerVariantId = e.classList.contains('from-pdp') ? e.dataset.variantId : null;
        const productUrl = e.getAttribute("data-product-url");
        
        // Build URL with variant parameter if needed
        const fetchUrl = triggerVariantId ? 
          `${productUrl}${productUrl.includes('?') ? '&' : '?'}variant=${triggerVariantId}` : 
          productUrl;
        
        fetch(fetchUrl)
          .then((e) => e.text())
          .then((t) => {
            let r = new DOMParser().parseFromString(t, "text/html"),
                i = r.querySelector("product-info");
            this.preprocessHTML(i);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, i.outerHTML);
            
            // Set the specific variant if from-pdp
            if (triggerVariantId && e.classList.contains('from-pdp')) {
              this.selectVariantInModal(triggerVariantId);
            }
            
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }
            super.show(e);
          })
          .finally(() => {
            e.removeAttribute("aria-disabled");
            e.classList.remove("loading");
            e.querySelector(".loading__spinner").classList.add("hidden");
            
            setTimeout(() => {
              const quickAddModal = document.querySelector('quick-add-modal');
              if (quickAddModal) {
                const submitButtons = document.querySelectorAll('.dont-open-cart');
                submitButtons.forEach((button) => {
                  if (button.classList.contains('dont-open-cart')) {
                    console.log('[Quick Add Modal] Removing dont-open-cart class from submit button.');
                    button.classList.remove('dont-open-cart');
                  }
                });
              }
            }, 1000);
          });
      }
      
      // New method to select specific variant in modal
      selectVariantInModal(variantId) {
        setTimeout(() => {
          const productInfo = this.modalContent.querySelector('product-info');
          if (!productInfo) return;
          
          // Update variant input
          const variantInput = productInfo.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Update variant selects to match the variant
          const variantSelects = productInfo.querySelector('variant-selects');
          if (variantSelects) {
            this.updateVariantSelects(variantSelects, variantId);
          }
          
          // Update product form if exists
          const productForm = productInfo.querySelector('product-form');
          if (productForm && productForm.updateVariant) {
            productForm.updateVariant(variantId);
          }
          
          console.log(`[Quick Add Modal] Selected variant: ${variantId}`);
        }, 100);
      }
      
      // Helper method to update variant selects
      updateVariantSelects(variantSelects, variantId) {
        try {
          // Get variant data from script tag
          const variantScript = variantSelects.querySelector('script[type="application/json"]');
          if (!variantScript) return;
          
          const variants = JSON.parse(variantScript.textContent);
          const selectedVariant = variants.find(v => v.id == variantId);
          
          if (!selectedVariant) return;
          
          // Update select elements to match variant options
          const selects = variantSelects.querySelectorAll('select');
          selects.forEach((select, index) => {
            const optionValue = selectedVariant[`option${index + 1}`];
            if (optionValue) {
              const option = select.querySelector(`option[value="${optionValue}"]`);
              if (option) {
                select.value = optionValue;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
          
          // Update selected variant data
          const selectedVariantScript = variantSelects.querySelector('[data-selected-variant]');
          if (selectedVariantScript) {
            selectedVariantScript.innerHTML = JSON.stringify(selectedVariant);
          }
          
        } catch (error) {
          console.error('[Quick Add Modal] Error updating variant selects:', error);
        }
      }
      
      preprocessHTML(e) {
        // Add from-pdp class if trigger button has it
        if (this.currentTrigger && this.currentTrigger.classList.contains('from-pdp')) {
          e.classList.add('from-pdp');
        }
        
        e.classList.forEach((className) => {
          if (className.startsWith("color-") || className === "gradient") {
            this.modalContent.classList.add(className);
          }
        });
        
        this.preventDuplicatedIDs(e);
        this.removeDOMElements(e);
        this.removeGalleryListSemantic(e);
        this.updateImageSizes(e);
        this.preventVariantURLSwitching(e);
      }
      
      preventVariantURLSwitching(e) {
        e.setAttribute("data-update-url", "false");
      }
      
      removeDOMElements(e) {
        let t = e.querySelector("pickup-availability");
        t && t.remove();
        let r = e.querySelector("product-modal");
        r && r.remove();
        let i = e.querySelectorAll("modal-dialog");
        i && i.forEach((el) => el.remove());
      }
      
      preventDuplicatedIDs(e) {
        let t = e.dataset.section,
            r = t,
            i = `quickadd-${t}`;
        
        e.innerHTML = e.innerHTML.replaceAll(r, i);
        Array.from(e.attributes).forEach((attr) => {
          if (attr.value.includes(r)) {
            e.setAttribute(attr.name, attr.value.replace(r, i));
          }
        });
        e.dataset.originalSection = t;
      }
      
      removeGalleryListSemantic(e) {
        let t = e.querySelector('[id^="Slider-Gallery"]');
        if (t) {
          t.setAttribute("role", "presentation");
          t.querySelectorAll('[id^="Slide-"]').forEach((slide) => 
            slide.setAttribute("role", "presentation")
          );
        }
      }
      
      updateImageSizes(e) {
        let t = e.querySelector(".product"),
            r = t?.classList.contains("product--columns");
        if (!r) return;
        
        let i = t.querySelectorAll(".product__media img");
        if (!i.length) return;
        
        let a = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        
        if (t.classList.contains("product--medium")) {
          a = a.replace("715px", "605px");
        } else if (t.classList.contains("product--small")) {
          a = a.replace("715px", "495px");
        }
        
        i.forEach((img) => img.setAttribute("sizes", a));
      }
    }
  );


